import React, { lazy, Suspense } from "react";
import Loader from "../component/Spin";
// import MainAppScreen from '../screens/mainScreen';
// import Cafe from '../screens/cafe';
// import SelecteReserveDateAndTime from '../screens/reserve/SelecteReserveDateAndTime';
// import ReservePayment from '../screens/payment';
// import SelectHowToPayReserve from '../screens/payment/SelectHowToPayReserve';
// import UserProfile from '../screens/userProfile';
// import UserCredit from '../screens/credit';
// import OtherAmounts from '../screens/credit/OtherAmounts';
// import MyReserve from '../screens/myReserves';
// import MyReserveDetails from '../screens/myReserves/MyReserveDetails';
// import PayRedirectScreen from '../screens/payment/PayRedirectScreen';
// import FinancialTransaction from '../screens/financialTransaction';
// import Favorites from '../screens/favorites';
import ChangePassword from '../screens/setPassword/ChangePassword';
// import ChannelMessage from '../screens/channelMessage';
// import Ticket from '../screens/ticket';
// import SendNewTicket from '../screens/ticket/SendNewTicket';
// import TicketDetails from '../screens/ticket/TicketDetails';
// import CafeTables from '../screens/reserve/cafeTables/CafeTables';
// import TablesLocation from '../screens/cafe/tablesLocation/TablesLocation';
// import MyComments from '../screens/myComments';
// import AddNewComment from '../screens/myComments/AddNewComment';
// import CreditReport from '../screens/credit/CreditReport';
import SetNewPassword from '../screens/setPassword/SetNewPassword';
import SetPassword from '../screens/setPassword/SetPassword';
// import ProfileMenu from '../screens/userProfile/ProfileMenu';
// import SelectAvatar from '../screens/userProfile/SelectAvatar';
// import IntroducedCafes from '../screens/introducedCafes';
// import SearchCafes from '../screens/searchCafes';
// import SearchCafesFilters from '../screens/searchCafes/filters';
// import AboutRsee from '../screens/aboutRsee/AboutRsee';
// import SeeMoreCafes from '../screens/seeMoreCafes/SeeMoreCafes';
// import RseePackages from '../screens/packages';
// import ChargePackage from '../screens/packages/chargePackage';
// import ChargeRsee from '../screens/packages/chargeRsee';
// import InviteFriends from '../screens/inviteFriends';

const MainAppScreen = lazy(() => import('../screens/mainScreen'));

const SeeMoreCafes = lazy(() => import('../screens/seeMoreCafes/SeeMoreCafes'));

const Cafe = lazy(() => import('../screens/cafe'));
const TablesLocation = lazy(() => import('../screens/cafe/tablesLocation/TablesLocation'));

const SelecteReserveDateAndTime = lazy(() => import('../screens/reserve/SelecteReserveDateAndTime'));
const CafeTables = lazy(() => import('../screens/reserve/cafeTables/CafeTables'));

const ReservePayment = lazy(() => import('../screens/payment'));
const SelectHowToPayReserve = lazy(() => import('../screens/payment/SelectHowToPayReserve'));
const PayRedirectScreen = lazy(() => import('../screens/payment/PayRedirectScreen'));

const UserProfile = lazy(() => import('../screens/userProfile'));
const ProfileMenu = lazy(() => import('../screens/userProfile/ProfileMenu'));
const SelectAvatar = lazy(() => import('../screens/userProfile/SelectAvatar'));

const UserCredit = lazy(() => import('../screens/credit'));
const OtherAmounts = lazy(() => import('../screens/credit/OtherAmounts'));
const CreditReport = lazy(() => import('../screens/credit/CreditReport'));

const MyReserve = lazy(() => import('../screens/myReserves'));
const MyReserveDetails = lazy(() => import('../screens/myReserves/MyReserveDetails'));

const FinancialTransaction = lazy(() => import('../screens/financialTransaction'));

const Favorites = lazy(() => import('../screens/favorites'));

const ChannelMessage = lazy(() => import('../screens/channelMessage'));

const MyComments = lazy(() => import('../screens/myComments'));
const AddNewComment = lazy(() => import('../screens/myComments/AddNewComment'));

const Ticket = lazy(() => import('../screens/ticket'));
const SendNewTicket = lazy(() => import('../screens/ticket/SendNewTicket'));
const TicketDetails = lazy(() => import('../screens/ticket/TicketDetails'));

const IntroducedCafes = lazy(() => import('../screens/introducedCafes'));

const SearchCafes = lazy(() => import('../screens/searchCafes'));
const SearchCafesFilters = lazy(() => import('../screens/searchCafes/filters'));

const AboutRsee = lazy(() => import('../screens/aboutRsee/AboutRsee'));

const RseePackages = lazy(() => import('../screens/packages'));
const ChargePackage = lazy(() => import('../screens/packages/chargePackage'));
const ChargeRsee = lazy(() => import('../screens/packages/chargeRsee'));

const InviteFriends = lazy(() => import('../screens/inviteFriends'));

export const routes = [
  {
    path: '/',
    // element: (
    //   <Suspense fallback={<Loader />}>
    //     <MainAppScreen />
    //   </Suspense>
    // ),
    component: MainAppScreen,
    exact: true,
  },
  {
    path: '/see-more',
    component: SeeMoreCafes,
    exact: true,
  },
  {
    path: `/cafeDetaile-cafeId=:cafeId`,
    component: Cafe,
    exact: true,
  },
  {
    path: '/select-date-and-time',
    component: SelecteReserveDateAndTime,
    exact: true,
  },
  {
    path: '/select-table',
    component: CafeTables,
    exact: true,
  },
  {
    path: '/reserve-payment',
    component: ReservePayment,
    exact: true,
  },
  {
    path: '/payment-manner',
    component: SelectHowToPayReserve,
    exact: true,
  },
  {
    path: '/pay-report',
    component: PayRedirectScreen,
    exact: true,
  },
  {
    path: '/edite-profile',
    component: UserProfile,
    exact: true,
  },
  {
    path: '/select-avatar',
    component: SelectAvatar,
    exact: true,
  },
  {
    path: '/my-profile',
    component: ProfileMenu,
    exact: true,
  },
  {
    path: '/credit',
    component: UserCredit,
    exact: true,
  },
  {
    path: '/other-amounts',
    component: OtherAmounts,
    exact: true,
  },
  {
    path: '/financial-transaction',
    component: FinancialTransaction,
    exact: true,
  },
  {
    path: '/favorites',
    component: Favorites,
    exact: true,
  },
  {
    path: '/my-reserves',
    component: MyReserve,
    exact: true,
  },
  {
    path: '/my-reserve-details',
    component: MyReserveDetails,
    exact: true,
  },
  {
    path: '/my-comments',
    component: MyComments,
    exact: true,
  },
  {
    path: '/add-new-comment',
    component: AddNewComment,
    exact: true,
  },
  {
    path: '/messages',
    component: ChannelMessage,
    exact: true,
  },
  {
    path: '/ticket',
    component: Ticket,
    exact: true,
  },
  {
    path: '/new-ticket',
    component: SendNewTicket,
    exact: true,
  },
  {
    path: '/ticket-details',
    component: TicketDetails,
    exact: true,
  },
  {
    path: '/introduced-cafe',
    component: IntroducedCafes,
    exact: true,
  },
  {
    path: '/credit-report',
    component: CreditReport,
    exact: true,
  },
  {
    path: '/search-cafes',
    component: SearchCafes,
    exact: true,
  },
  {
    path: '/search-cafes-filters',
    component: SearchCafesFilters,
    exact: true,
  },
  {
    path: '/packages',
    component: RseePackages,
    exact: true,
  },
  {
    path: '/charge-package',
    component: ChargePackage,
    exact: true,
  },
  {
    path: '/charge-rsee',
    component: ChargeRsee,
    exact: true,
  },
  {
    path: '/about-rsee',
    component: AboutRsee,
    exact: true,
  },
  {
    path: '/invite-friends',
    component: InviteFriends,
    exact: true,
  },
  {
    path: '/tables-location',
    component: TablesLocation,
    exact: true,
  },
];
